'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirectTo = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _safeMode = require('./safeMode');

var noop = function noop() {};

var redirectTo = exports.redirectTo = function redirectTo(redirectUrl, options) {
  var onRedirect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noop;

  var overrideKey = 'HUB-HTTP_IGNORE_REDIRECTS';
  var isTrue = function isTrue(v) {
    return v && v.toLowerCase() === 'true';
  };

  var skipConditions = [[function () {
    return options.ignoreRedirect;
  }, 'ignoreRedirect option is set'], [function () {
    return options.localStorage && isTrue(options.localStorage.getItem(overrideKey));
  }, 'local storage key ' + overrideKey + ' is set to "true"'], [function () {
    return (0, _safeMode.isSafeMode)(options);
  }, 'safe mode is enabled']];

  var condition = skipConditions.find(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        predicate = _ref2[0];

    return predicate();
  });

  if (condition) {
    // eslint-disable-next-line no-console
    console.log('[hub-http] Skipping redirect because ' + condition[1]);
    return false;
  }

  onRedirect(options);
  options.location.href = redirectUrl;
  return true;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hub-http/static-1.179/js/helpers/location.js
// module id = 357
// module chunks = 2 3